// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1-NUj","approved":"Status_approved__2v_GS","rejected":"Status_rejected__w5t3g","expired":"Status_expired__1Occu","label":"Status_label__3Eb6W"};